import React, { useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import logoDark from "../assets/logo.svg";
import logoLight from "../assets/logo-light.svg";
import { Container } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";
import { useI18n } from "../i18n/I18nContext";
import "./assets/sidebar.scss";
import { Routes } from "../constants/Routes";
import { useShallowEqualSelector } from "../hooks/useShallowSelector";
import { userInformationSelector } from "../reducers/UserReducer";

interface Props {
  readonly openMenu: boolean;
}

const Sidebar = ({ openMenu }: Props) => {
  const [resources, setResources] = useState<boolean>(false);
  const [settings, setSettings] = useState<boolean>(false);
  const [products, setProducts] = useState<boolean>(false);
  const [shipment, setShipment] = useState<boolean>(false);
  const userInformation = useShallowEqualSelector(userInformationSelector);
  const { translate } = useI18n();
  useEffect(() => {
    const verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document?.body?.classList?.remove("vertical-sidebar-enable");
      });
    }
  });
  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (document.documentElement?.getAttribute("data-sidebar-size") === "sm-hover") {
      document.documentElement?.setAttribute("data-sidebar-size", "sm-hover-active");
    } else if (document.documentElement?.getAttribute("data-sidebar-size") === "sm-hover-active") {
      document.documentElement?.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      document.documentElement?.setAttribute("data-sidebar-size", "sm-hover");
    }
  };

  const menuItemsChief = useMemo(() => {
    return [
      {
        id: "1",
        label: translate("TITTLE_NAVBAR_MENU_MONITORING"),
        icon: "bx bx-stats",
        link: Routes.MonitoringOrders,
      },
      {
        label: translate("TITTLE_NAVBAR_MENU_PRODUCTS"),
        id: "2",
        link: Routes.Products,
        icon: "mdi mdi-package-down fs-5",
        click: function (e: any) {
          e.preventDefault();
          setProducts((prev) => !prev);
        },
        stateVariables: products,
        subItems: [
          {
            id: "Приемка",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_ACCEPTANCE"),
            link: Routes.ProductsAcceptance,
            parentId: "2",
          },
          {
            id: "Маркировка",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_MARKING"),
            link: Routes.ProductsMarking,
            parentId: "2",
          },
          {
            id: "Комплектация",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_EQUIPMENT"),
            link: Routes.ProductsEquipment,
            parentId: "2",
          },
          {
            id: "Хранение",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_STORAGE"),
            link: Routes.ProductsStorage,
            parentId: "2",
          },
          {
            id: "Зоны",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_ZONES"),
            link: Routes.ProductsZones,
            parentId: "2",
          },
          {
            id: "Перемещение",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_MOVEMENT"),
            link: Routes.ProductsMovement,
            parentId: "2",
          },
          {
            id: "Интвентаризация",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_INVENTORY"),
            link: Routes.ProductsInventory,
            parentId: "2",
          },
        ],
      },
      {
        label: translate("TITTLE_NAVBAR_MENU_SHIPMENT"),
        id: "3",
        icon: "mdi mdi-truck",
        link: Routes.Shipment,
        click: function (e: any) {
          e.preventDefault();
          setShipment((prev) => !prev);
        },
        stateVariables: shipment,
        subItems: [
          {
            id: "Касса",
            label: translate("TITTLE_NAVBAR_MENU_SHIPMENT_CASHBOX"),
            link: Routes.ShipmentCashBox,
            parentId: "3",
          },
          {
            id: "Выдача клиенту",
            label: translate("TITTLE_NAVBAR_MENU_SHIPMENT_ISSUE_CLIENT"),
            link: Routes.ShipmentIssueClient,
            parentId: "3",
          },
          {
            id: "Отгрузка",
            label: translate("TITTLE_NAVBAR_MENU_SHIPMENT"),
            link: Routes.ShipmentShipment,
            parentId: "3",
          },
          {
            id: "Возврат",
            label: translate("TITTLE_NAVBAR_MENU_SHIPMENT_RETURN"),
            link: Routes.ShipmentReturns,
            parentId: "3",
          },
        ],
      },
      {
        label: translate("TITTLE_NAVBAR_MENU_STAFF"),
        id: "4",
        link: Routes.Staff,
        icon: "mdi mdi-account-multiple",
        click: function (e: any) {
          e.preventDefault();
          setResources((prev) => !prev);
        },
        stateVariables: resources,
        subItems: [
          {
            id: "Доступ",
            label: translate("TITTLE_NAVBAR_MENU_STAFF_PERMISSIONS"),
            link: Routes.StaffPermissions,
            parentId: "4",
          },
        ],
      },
      {
        label: translate("TITTLE_NAVBAR_MENU_SETTINGS"),
        id: "5",
        link: Routes.Settings,
        icon: "mdi mdi-cog-outline",
        click: function (e: any) {
          e.preventDefault();
          setSettings((prev) => !prev);
        },
        stateVariables: settings,
        subItems: [
          {
            id: "Сотрудники",
            label: translate("TITTLE_NAVBAR_MENU_SETTINGS_EMPLOYEES"),
            link: Routes.SettingsEmployees,
            parentId: "5",
          },
        ],
      },
    ];
  }, [products, resources, settings, shipment, translate]);

  const menuItemsStockmanDc = useMemo(() => {
    return [
      {
        id: "1",
        label: translate("TITTLE_NAVBAR_MENU_MONITORING"),
        icon: "bx bx-stats",
        link: Routes.MonitoringOrders,
      },
      {
        label: translate("TITTLE_NAVBAR_MENU_PRODUCTS"),
        id: "2",
        link: Routes.Products,
        icon: "mdi mdi-package-down fs-5",
        click: function (e: any) {
          e.preventDefault();
          setProducts((prev) => !prev);
        },
        stateVariables: products,
        subItems: [
          {
            id: "Приемка",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_ACCEPTANCE"),
            link: Routes.ProductsAcceptance,
            parentId: "2",
          },
          {
            id: "Маркировка",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_MARKING"),
            link: Routes.ProductsMarking,
            parentId: "2",
          },
          {
            id: "Комплектация",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_EQUIPMENT"),
            link: Routes.ProductsEquipment,
            parentId: "2",
          },
          {
            id: "Хранение",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_STORAGE"),
            link: Routes.ProductsStorage,
            parentId: "2",
          },
          {
            id: "Перемещение",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_MOVEMENT"),
            link: Routes.ProductsMovement,
            parentId: "2",
          },
        ],
      },
      {
        label: translate("TITTLE_NAVBAR_MENU_SHIPMENT"),
        id: "3",
        icon: "mdi mdi-truck",
        link: Routes.Shipment,
        click: function (e: any) {
          e.preventDefault();
          setShipment((prev) => !prev);
        },
        stateVariables: shipment,
        subItems: [
          {
            id: "Касса",
            label: translate("TITTLE_NAVBAR_MENU_SHIPMENT_CASHBOX"),
            link: Routes.ShipmentCashBox,
            parentId: "3",
          },
          {
            id: "Отгрузка",
            label: translate("TITTLE_NAVBAR_MENU_SHIPMENT"),
            link: Routes.ShipmentShipment,
            parentId: "3",
          },
        ],
      },
    ];
  }, [products, shipment, translate]);

  const menuItemsStockmanPup = useMemo(() => {
    return [
      {
        id: "1",
        label: translate("TITTLE_NAVBAR_MENU_MONITORING"),
        icon: "bx bx-stats",
        link: Routes.MonitoringOrders,
      },
      {
        label: translate("TITTLE_NAVBAR_MENU_PRODUCTS"),
        id: "2",
        link: Routes.Products,
        icon: "mdi mdi-package-down fs-5",
        click: function (e: any) {
          e.preventDefault();
          setProducts((prev) => !prev);
        },
        stateVariables: products,
        subItems: [
          {
            id: "Приемка",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_ACCEPTANCE"),
            link: Routes.ProductsAcceptance,
            parentId: "2",
          },
          {
            id: "Маркировка",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_MARKING"),
            link: Routes.ProductsMarking,
            parentId: "2",
          },
          {
            id: "Хранение",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_STORAGE"),
            link: Routes.ProductsStorage,
            parentId: "2",
          },
          {
            id: "Перемещение",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_MOVEMENT"),
            link: Routes.ProductsMovement,
            parentId: "2",
          },
        ],
      },
      {
        label: translate("TITTLE_NAVBAR_MENU_SHIPMENT"),
        id: "3",
        icon: "mdi mdi-truck",
        link: Routes.Shipment,
        click: function (e: any) {
          e.preventDefault();
          setShipment((prev) => !prev);
        },
        stateVariables: shipment,
        subItems: [
          {
            id: "Касса",
            label: translate("TITTLE_NAVBAR_MENU_SHIPMENT_CASHBOX"),
            link: Routes.ShipmentCashBox,
            parentId: "3",
          },
          {
            id: "Отгрузка",
            label: translate("TITTLE_NAVBAR_MENU_SHIPMENT"),
            link: Routes.ShipmentShipment,
            parentId: "3",
          },
          {
            id: "Возврат",
            label: translate("TITTLE_NAVBAR_MENU_SHIPMENT_RETURN"),
            link: Routes.ShipmentReturns,
            parentId: "3",
          },
        ],
      },
    ];
  }, [products, shipment, translate]);

  const menuItemsLoader = useMemo(() => {
    return [
      {
        id: "1",
        label: translate("TITTLE_NAVBAR_MENU_MONITORING"),
        icon: "bx bx-stats",
        link: Routes.MonitoringOrders,
      },
      {
        label: translate("TITTLE_NAVBAR_MENU_PRODUCTS"),
        id: "2",
        link: Routes.Products,
        icon: "mdi mdi-package-down fs-5",
        click: function (e: any) {
          e.preventDefault();
          setProducts((prev) => !prev);
        },
        stateVariables: products,
        subItems: [
          {
            id: "Хранение",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_STORAGE"),
            link: Routes.ProductsStorage,
            parentId: "2",
          },
          {
            id: "Зоны",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_ZONES"),
            link: Routes.ProductsZones,
            parentId: "2",
          },
          {
            id: "Перемещение",
            label: translate("TITTLE_NAVBAR_MENU_PRODUCTS_MOVEMENT"),
            link: Routes.ProductsMovement,
            parentId: "2",
          },
        ],
      },
    ];
  }, [products, translate]);

  const menuItems = useMemo(() => {
    return userInformation?.roleName === "CHIEF"
      ? menuItemsChief
      : userInformation?.roleName === "LOADER"
      ? menuItemsLoader
      : userInformation?.roleName === "STOCKMAN-DC"
      ? menuItemsStockmanDc
      : userInformation?.roleName === "STOCKMAN-PUP"
      ? menuItemsStockmanPup
      : null;
  }, [userInformation, menuItemsStockmanPup, menuItemsStockmanDc, menuItemsLoader, menuItemsChief]);

  return (
    <React.Fragment>
      <div className={`app-menu navbar-menu ${openMenu && "mobile-menu"}`}>
        <div className="navbar-brand-box">
          <NavLink to="/" className="logo logo-dark">
            <span className="logo-lg">
              <img src={logoDark} alt="" height="17" />
            </span>
          </NavLink>

          <NavLink to="/" className="logo logo-light">
            <span className="logo-lg">
              <img src={logoLight} alt="" height="17" />
            </span>
          </NavLink>
          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line" />
          </button>
        </div>
        <div id="scrollbar">
          <Container fluid={true}>
            <div id="two-column-menu" />
            <ul className="navbar-nav" id="navbar-nav">
              <HorizontalLayout menuItems={menuItems} />
            </ul>
          </Container>
        </div>
      </div>
      <div className="vertical-overlay" />
    </React.Fragment>
  );
};

export default Sidebar;
